<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ comptes?.length || 0 }} compte(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addCompte()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Libellé</th>
          <th>Numéro</th>
          <th>Type</th>
          <th>Banque</th>
          <th>Solde actuel</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of comptes">
          <td>{{ item?.code }}</td>
          <td>{{ item?.libelle }}</td>
          <td>{{ item?.numero }}</td>
          <td><span class="badge badge-info">{{ item?.type }}</span></td>
          <td>{{ item?.banque }}</td>
          <td class="text-right" [ngClass]="item?.soldeActuel >= 0 ? 'text-success' : 'text-danger'">
            {{ item?.soldeActuel | number:'1.0-0' }} FCFA
          </td>
          <td>
            <span class="badge" [ngClass]="{
              'badge-success': item?.statut === 'ACTIF',
              'badge-secondary': item?.statut === 'INACTIF',
              'badge-danger': item?.statut === 'CLOTURE'
            }">{{ item?.statut }}</span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editCompte(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteCompte(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
